import { axios } from '@Root/API'

export const edit = ({ id, name }) => {
	return axios.put(`edit/ordinand/${id}`, { name })
}
